<template>
  <div class="navbar navbarDialog">
    <div class="app-logo" :class="{ small: isChangeMenu }">
      <img :src="companyLogo.company_icon" v-if="!isChangeMenu" width="120" height="30" alt="LOGO" />
      <img :src="companyLogo.company_small_icon" v-else width="33" height="30" alt="LOGO" />
    </div>
    <div class="changeMenu" @click="changeMenu" :class="{ small: isChangeMenu }">
      <svg-icon icon-class="changeMenu"></svg-icon>
    </div>
    <div v-if="hasServiceMenu"> 
      <!-- <span class="change-modle" @click="toService">切换</span>
      <span class="change-name">当前管理模式</span> -->
      <div class="switchMode" @click="toService">
        <div class="img">
          <img src="../../assets/images/tab_btn.png" alt="">
        </div>
        <p>切换客服模式</p>
      </div>
    </div>
    <div class="navbar-right-module">
      <div class="newFunction cursor-point" @click="newFuntionPop">
          <div class="top_fun">
            新功能
          </div>
          <div class="btm_fun">
          </div>
      </div>
      <div class="navbar-right-item" @click="goPath('notice')">
        <svg-icon icon-class="navbar_info" style="margin-right: 2px;"></svg-icon>
        <el-badge v-if="systemNum > 0" :value="systemNum" :max="99" class="item">
          系统公告
        </el-badge>
        <el-badge v-else class="item">
          系统公告
        </el-badge>
      </div>
      <a :href="downloadUrl" target="_blank" class="navbar-right-item">
        <svg-icon icon-class="navbar_download" style="margin-right: 2px;"></svg-icon>下载中心
      </a>
      <div class="navbar-right-item navbar-userinfo">
        <el-dropdown trigger="click" @command="handlerChangePage">
          <span class="el-dropdown-link" style="display: flex;max-width: 120px;">
            <p
              style="max-width: 100px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;text-align: center"
              :title="userInfo.csName"
            >{{userInfo.csName}}</p>
            <i class="el-icon-arrow-down el-icon--right" style="line-height: 55px;"></i>
          </span>
          <el-dropdown-menu class="dropdownMenu" slot="dropdown">
            <el-dropdown-item v-if="hasServiceMenu" @click.native="toService">切换客服模式</el-dropdown-item>
            <el-dropdown-item command="account">企业账户</el-dropdown-item>
            <el-dropdown-item command="pwd">修改密码</el-dropdown-item>
            <el-dropdown-item command="logout">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown trigger="click" class="userAvatar-container" @command="handlerChangeStatus">
          <span class="el-dropdown-link userAvatar" v-if="userStatus">
            <img :src="avatarX(userInfo.csHeadimg)" alt />
            <svg-icon
              class="user-status"
              style="width: 14px;height:
            14px;"
              icon-class="online-status"
            ></svg-icon>
          </span>
          <span class="el-dropdown-link userAvatar offline" v-else>
            <img :src="avatarX(userInfo.csHeadimg)" alt />
            <svg-icon
              class="user-status"
              style="width: 14px;height:
            14px;"
              icon-class="offline-status"
            ></svg-icon>
          </span>
          <el-dropdown-menu slot="dropdown" class="user-status-dropdown">
            <el-dropdown-item command="online">
              <svg-icon
                icon-class="online-status"
                style=" margin-right: 5px;width: 14px;height: 14px;"
              ></svg-icon>在线
            </el-dropdown-item>
            <el-dropdown-item command="offline">
              <svg-icon
                icon-class="offline-status"
                style=" margin-right: 5px;width: 14px;height: 14px;"
              ></svg-icon>休息
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <el-dialog
      :visible.sync="newFunctionDialog"
      width="680px"
      :modal-append-to-body="false"
      >
      <div class="topNav">
        <p>微聊{{versionNew}}版本</p>
        <span>更新说明</span>
      </div>
      <div class="middleNav">
        <p v-for="(item,index) in newFunContent" :key="index" v-html="index + 1 +'、'+item.content"></p>
      </div>
      <span slot="footer" class="dialog-footer">
          <span class="cursor-point" @click="goToMore">查看更多》</span>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import avatar0 from "@/assets/images/client_avatar_empty.png";
import avatar1 from "@/assets/images/client_avatar1.png";
import avatar2 from "@/assets/images/client_avatar2.png";
import avatar3 from "@/assets/images/client_avatar3.png";
import avatar4 from "@/assets/images/client_avatar4.png";
import avatar5 from "@/assets/images/client_avatar5.png";
import avatar6 from "@/assets/images/client_avatar6.png";
import avatar7 from "@/assets/images/client_avatar7.png";
export default {
  name: "navbar",
  data() {
    return {
      isFold: false,
      downloadUrl: process.env.VUE_APP_WL_DOWNLOAD,
      isChangeMenu:false,
      newFunctionDialog:false,
      systemNum:0,
      newFunContent:[],
      versionNew:''
    };
  },
  computed: {
    roles() {
      return this.$store.getters.roles;
    },
    userInfo() {
      return this.$store.getters.user;
    },
    hasServiceMenu() {
      let allMenu = this.$store.state.user.allMenu;
      let hasService = false;
      allMenu.map(item => {
        if (item.path == "customerMode" && item.children.length > 0) {
          hasService = true;
        }
      });
      return hasService;
    },
    userStatus() {
      let status = this.$store.state.user.agentStatus;
      if (status == "online") {
        return true;
      } else {
        return false;
      }
    },
    companyLogo() {
      return this.$store.state.user.logo;
    }
  },

  mounted() {
    this.logUnReadNum()
    this.latestLogTips()
  },
  methods: {
    /**
     * 显示访客头像
     * 截取头像名称中的数字
     */
    avatarX(avatar) {
      if (!avatar) {
        return false;
      }
      let reg = new RegExp(/(http|https):\/\/([\w.]+\/?)\S*/, "g");
      if (reg.test(avatar)) {
        return avatar;
      } else {
        const img = avatar.substring(avatar.length - 5, avatar.length - 4);
        switch (img) {
          case "y":
            return avatar0;
            break;
          case "1":
            return avatar1;
            break;
          case "2":
            return avatar2;
            break;
          case "3":
            return avatar3;
            break;
          case "4":
            return avatar4;
            break;
          case "5":
            return avatar5;
            break;
          case "6":
            return avatar6;
            break;
          case "7":
            return avatar7;
            break;
          default:
            return avatar;
            break;
        }
      }
    },
    changeMenu(){
      this.isChangeMenu=!this.isChangeMenu
      eventBus.$emit("isChangeMenuType", this.isChangeMenu);
      console.log(this.isChangeMenu)
    },
    newFuntionPop(){
      this.newFunctionDialog = true
    },
    goToMore(){
      this.$router.push({path:'/setting-notice'})
      this.newFunctionDialog = false
    },
    toService() {
      this.$store.dispatch('user/userInfo').then(res => {
        if(this.hasServiceMenu){
            window.location.href = process.env.VUE_APP_CHAT_URL;
        }else{
          this.$message({
              message: "暂无权限访问",
              type: "error"
            });
        }
      })
      // 
    },
    goPath(type) {
      let url = "";
      if (type == "notice") {
        url = "/setting-notice";
      }
      this.$router.push({
        path: url
      });
    },
    sideBarToggle() {
      this.isFold = !this.isFold;
      this.$store.dispatch("app/toggleSideBar");
    },
    /**
     * 切换页面
     */
    handlerChangePage(command) {
      switch (command) {
        case "logout":
          this.$store.dispatch("user/logout").then(res => {
            window.location.reload();
          });
          break;
        case "account":
          this.$router.push({
            path: "/business"
          });
          break;
        case "pwd":
          this.$router.push({
            path: "/setting-change-pwd"
          });
          break;
      }
    },
    // 
    logUnReadNum() {
      this.$http
        .logUnReadCount({})
        .then(res => {
          if (res.status == 1) {
            this.systemNum = res.data
          } else {
            this.$message({
              message: "查询失败",
              type: "error"
            });
          }
        });
    },
    /**
     * 修改客服状态
     * @param command
     */
    handlerChangeStatus(command) {
      let currentRoute = this.$route.name;
      this.$http
        .userStatusAPI({
          status: command
        })
        .then(res => {
          if (res.status == 1) {
            this.$store.dispatch("user/changeUserStatus", command);
            if (currentRoute == "index") {
              eventBus.$emit("reloadIndexTable");
            }
            this.$message({
              message: "状态切换成功",
              type: "success"
            });
          } else {
            this.$message({
              message: "修改状态失败",
              type: "error"
            });
          }
        });
    },
    // 弹窗最后一条
    latestLogTips() {
      this.$http
        .latestLog({})
        .then(res => {
          if (res.status == 1) {
            this.newFunContent = res.data.list
            this.versionNew = res.data.version 
          } else {
            this.$message({
              message: "查询失败",
              type: "error"
            });
          }
        });
    },
  }
};
</script>
<style lang="scss">
.dropdownMenu {
  width: 135px !important;
}
.cursor-point{
  cursor: pointer;
}
.navbarDialog{
  .el-dialog{
    border-radius: 6px!important;
    .el-dialog__body{
      padding: 30px 20px 0;
    }
    position: relative;
    .el-dialog__header{
      height: 150px;
      background: url(../../assets/images/navbarBg.jpg) no-repeat;
      background-size: cover;
      border-radius:6px 6px 0 0;
    }
    .el-dialog__headerbtn{
      .el-dialog__close{
        color: #fff;
        font-size: 30px;
        font-weight: 600;
      }
    } 
    .topNav{
      position: absolute;
      top: 40px;
      left: 40px;
      color: #fff;
      // font-weight: bold;
      p{
        font-size: 26px;
        line-height: 26px;
      }
      span{
        font-size: 20px;
      }
    }
    .middleNav{
      height: auto;
      max-height: 350px;
      overflow-y: scroll;
      p{
        line-height: 30px;
      }
    }
    .el-dialog__footer{
      text-align: right;
      color: cornflowerblue;
    }
  }
}
.navbar {
  display: flex;
  align-items: center;
  color: #fff;
  .switchMode{
    cursor: pointer;
    width: 140px;
    height: 44px;
    background: url(../../assets/images/index_mode_Bg.png);
    background-size: cover;
    position: relative;
    .img{
      width: 31px;
      height: 31px;
      display: inline-block;
      margin: 6px 8px;
      image{
        width: 100%;
        height: 100%;
        display: block;
      }
    }
    p{
      color: #fff;
      position: absolute;
      top: -5px;
      left: 37px;
      font-size: 14px;
    }
  }
  .app-logo {
    background-color: #1d2b36;
    width: 200px;
    height: 55px;
    // height: $headerHeight;
    // line-height: $headerHeight;
    // text-align: center;
	padding-left: 25px;
    font-size: 0;
    &.small{
        width: 60px;
        height: 60px;
		padding-left: 0;
		text-align: center;
    }
    img {
      vertical-align: middle;
    }
  }

  .navbar-toggle-icon {
    font-size: 28px;
    line-height: 28px;
    cursor: pointer;
  }
  .changeMenu {
    margin-left:16px;
    &.small {
      transform: rotate(180deg);
    }
  }
  .change-modle {
    display: inline-block;
    border-radius: 2px;
    width: 41px;
    height: 19px;
    line-height: 19px;
    font-size: 12px;
    text-align: center;
    color: #fff;
    background-color: #6c8abe;
    cursor: pointer;
    margin-left: 11px;
    margin-right: 5px;
  }
  .change-name {
    color:#576379
  }
  .navbar-right-module {
    display: flex;
    flex: 1;
    justify-content: flex-end;
    padding-right: 30px;
    .newFunction{
      width:82px;
      height:44px;
      // background:rgba(222,235,254,1);
      // border-radius:0px 0px 6px px;
      .top_fun{
        height: 33px;
        font-size: 14px;
        text-align: center;
        line-height: 40px;
        color: #1890FF;
        font-weight: bold;
        background:#deebfe;
      }
      .btm_fun{
        width: 0;
        height: 0;
        border-right: 40px solid transparent;
        border-left: 40px solid transparent;
        border-top: 12px solid #deebfe;
      }
    }
    .navbar-right-item {
      margin-left: 27px;
      cursor: pointer;
      color:#333;
      &.navbar-userinfo {
        display: flex;
        align-items: center;

        .userAvatar-container {
          height: $headerHeight;
          display: flex;
          align-items: center;
          margin-left: 10px;
        }
        .el-dropdown-selfdefine {
          justify-content: flex-end;
          color:#333;
        }
        .userAvatar {
          position: relative;
          &.offline {
            filter: grayscale(100%);
            -webkit-filter: grayscale(100%);
          }
          .user-status {
            position: absolute;
            right: 0;
            bottom: 0;
          }

          img {
            display: block;
            width: 30px;
            height: 30px;
            border-radius: 50%;
            margin-right: 5px;
          }
        }
      }
      .item{
        line-height: 28px;
      }
      .el-badge{
        height: 28px!important;
      }
    }
  }
}
</style>
